import { Component, OnInit } from '@angular/core';
import { HttpserviceService } from '../../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../service/utils.service';
import { GlobalConfig } from '../../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs/Subject';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import { ConformMessageComponent } from '../../conform-message/conform-message/conform-message.component';
declare var moment: any;

@Component({
  selector: 'app-rental-inquiry',
  templateUrl: './rental-inquiry.component.html',
  styleUrls: ['./rental-inquiry.component.css']
})
export class RentalInquiryComponent implements OnInit {
  isList: Boolean = true;
  constructor(
    private servicesComponent: HttpserviceService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager,
    private modalService: BsModalService,
  ) { }
  bsModalRef: BsModalRef;
  totalItems: any = Number;
  inquires: any[] = [];
  page: any = { pageNumber: 1, pageSize: 20 };
  ngOnInit() {
    this.getSubscriberAsync();
  }

  getSubscriberAsync() {
    this.servicesComponent.getInquiresAsync(this.page)
      .then((response: any) => {
        if (response.success) {
          this.inquires = response.receiveObj.result.data;
          this.totalItems = response.receiveObj.result.total_rows;
          this.isList = this.inquires.length > 0 ? true : false;
        } 
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  pageChanged(event: any): void {
    this.page.pageNumber = event.page;
    this.page.pageSize = event.itemsPerPage;
    this.getSubscriberAsync();
  }

  updateInquires(id) {
    this.router.navigate(['./updateinquires', id]);
  }

  delete(id) {
    if (id > 0) {
      this.servicesComponent.deleteInquires(id)
        .then((response: any) => {
          if (response.success == true) {
            this.page.pageNumber = 1;
            this.getSubscriberAsync();
            this.toastr.success('Inquires delete successfully.', 'Success!');
          } 
        })
        .catch(error => {
          console.log(error);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    }
  }

  exportData() {
    var oldNum = this.page.pageNumber;
    this.page.pageNumber = 1;
    this.page.pageSize = 999999;
    this.servicesComponent.getInquiresAsync(this.page)
      .then((response: any) => {
        if (response.success) {
          this.inquires = response.receiveObj.result.data;
          this.totalItems = response.receiveObj.result.total_rows;
          this.isList = this.inquires.length > 0 ? true : false;

          var head = ['ID', 'Full Name', 'Phone', 'Email', 'Location', 'Property Type', 'Bedroom', 'Bathroom', 'Max  Price', 'Term', 'More Information', 'Date', 'Furnishing']
          this.inquires.forEach(function (value) {
            value.createdAt = moment(value.createdAt);
            value.createdAt = value.createdAt.format('DD/MM/YYYY');
          });
          new Angular2Csv(this.inquires, "Inquiries", { headers: (head) });

          this.page.pageNumber = oldNum;
          this.page.pageSize = 20;
          this.getSubscriberAsync();
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  callMessgaeConform(id: any) {
    const subject = new Subject<any>();
    this.config.confirmService = { confirmMessage: 'Do you want to delete the Inquiry?' };
    this.bsModalRef = this.modalService.show(ConformMessageComponent);
    this.bsModalRef.content.subject = subject;
    subject.asObservable().subscribe((data) => {
      if (data) {
        this.delete(id);
      }
      this.bsModalRef.hide();

    });
  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/rentalInquiry/rental-inquiry/rental-inquiry.component.ts